import { Button, Group, InputLabel } from '@mantine/core';

interface EnumButtonGroupProps<T extends string | number> {
  label?: string;
  options: { value: T; label: string }[];
  value: T[];
  onChange: (value: T[]) => void;
}

export function EnumButtonGroup<T extends string | number>({
  label,
  options,
  value,
  onChange,
}: EnumButtonGroupProps<T>) {
  const toggleOption = (option: T) => {
    const isSelected = value.includes(option);
    if (isSelected) {
      onChange(value.filter(item => item !== option));
    } else {
      onChange([...value, option]);
    }
  };

  return (
    <Group gap="xs" wrap="nowrap" display="block">
      {label && (
        <InputLabel display="block" mb="xs">
          {label}
        </InputLabel>
      )}
      {options.map(option => (
        <Button
          key={String(option.value)}
          type="button"
          onClick={() => toggleOption(option.value)}
          className="mantine-Button-root"
          data-active={value.includes(option.value)}
          style={{
            padding: 'var(--button-padding, 8px 16px)',
            marginRight: 'var(--button-gap, 8px)',
            marginBottom: 'var(--button-gap, 8px)',
            backgroundColor: value.includes(option.value)
              ? 'var(--mantine-color-blue-6)'
              : 'var(--mantine-color-gray-1)',
            color: value.includes(option.value)
              ? 'var(--mantine-color-white)'
              : 'var(--mantine-color-gray-9)',
            border: '1px solid var(--mantine-color-gray-3)',
            borderRadius: 'var(--mantine-radius-sm)',
            cursor: 'pointer',
            fontWeight: value.includes(option.value) ? '600' : '400',
            transition: 'all 200ms ease',
          }}
        >
          {option.label}
        </Button>
      ))}
    </Group>
  );
}
